<template>
  <th
    :class="{ 'datagrid__header--sortable': header.sortable, ...borderClass }"
    class="datagrid__header"
  >
    <div>
      <div class="d-flex">
        <div>
          <div>
            {{ header.text }}
          </div>
          <div v-if="header.rate" class="datagrid__rating">
            <span>{{ header.rate }}</span>
            <StarIcon class="datagrid__star-icon" />
          </div>
        </div>
        <div class="datagrid__sort-btn" @click="sort(header)">
          <template v-if="header.sortable">
            <v-icon v-bind="filterIconAttrs(sortDesc)"
              >icon-arrow-thin-up</v-icon
            >
            <v-icon
              v-bind="filterIconAttrs(!sortDesc)"
              class="datagrid__sort-icon--down"
              >icon-arrow-thin-up</v-icon
            >
          </template>
        </div>
      </div>
    </div>
  </th>
</template>

<script>
import { AVG_REVIEW_COLUMNS } from "@/enums/avg_review_columns";
import { SORT_TYPE } from "@/enums/sort-type";

export default {
  name: "ReviewsCategoriesTableHeader",
  components: {
    StarIcon: () => import("@/components/ui/Icons/StarIcon.vue")
  },
  props: {
    header: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      sortDesc: null,
      sortBy: null
    };
  },
  computed: {
    borderClass() {
      if (this.header.type !== "colorTriad") return;
      return {
        "datagrid__header--is-positive": this.header.value === "positive",
        "datagrid__header--is-neutral": this.header.value === "neutral",
        "datagrid__header--is-negative": this.header.value === "negative"
      };
    },
    orderDirection() {
      return (
        this.sortDesc !== null && {
          order_direction: this.sortDesc ? "desc" : "asc"
        }
      );
    },
    getSortOrder() {
      if (this.sortDesc) return SORT_TYPE.DESCENDING;
      if (this.sortDesc === null) return SORT_TYPE.DEFAULT;
      return SORT_TYPE.ASCENDING;
    }
  },
  created() {
    if (this.header.value === "reviews_count") {
      if (this.sortDesc === null) {
        this.sortDesc = true;
      } else if (this.sortDesc === true) {
        this.sortDesc = false;
      } else if (this.sortDesc === false) {
        this.sortDesc = null;
      }
      this.header.sortDesc = this.sortDesc;
    }
  },
  methods: {
    filterIconAttrs(sortDesc) {
      return {
        class: [
          "datagrid__sort-icon",
          {
            "datagrid__sort-icon--in-active": sortDesc === false,
            "datagrid__sort-icon--active": sortDesc == true
          }
        ],
        size: "20"
      };
    },
    sort(headerColumn) {
      this.$emit("reset-sort-desc");
      if (!headerColumn.sortable) return;

      if (this.sortBy && !this.sortDesc) {
        this.resetSort(headerColumn);
      } else {
        this.updateSort(headerColumn);
      }
      this.$emit("sort", {
        sortBy: this.sortBy,
        sortDesc: this.sortDesc,
        orderDirection: this.orderDirection,
        sortOrder: this.getSortOrder,
        eventActionName: headerColumn.event_action_name
      });
    },
    resetSort(headerColumn) {
      headerColumn.sortDesc = null;
      this.sortDesc = null;
      this.sortBy = null;
    },
    updateSort(headerColumn) {
      this.sortDesc = !this.sortDesc;
      headerColumn.sortDesc = this.sortDesc;
      this.sortBy = this.getSortBy(headerColumn);
    },
    getSortBy(headerColumn) {
      if (headerColumn.sort_value === AVG_REVIEW_COLUMNS.AVG_REVIEW_PERIOD) {
        return AVG_REVIEW_COLUMNS.AVERAGE;
      } else if (
        headerColumn.sort_value === AVG_REVIEW_COLUMNS.AVG_REVIEW_BEGINNING
      ) {
        return AVG_REVIEW_COLUMNS.AVERAGE_TOTAL;
      } else {
        return headerColumn.sort_value;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.datagrid {
  &__header {
    @include font-size(16px);
    font-weight: 500;
    color: #85868b !important;
    border: none !important;
    text-align: center;
    padding: $spacing * 2.2 0;
    max-width: 170px;
    & > * {
      display: flex;
      justify-content: center;
    }
    &:first-of-type {
      & > * {
        justify-content: flex-start;
      }
    }

    &--sortable {
      cursor: pointer;
      > div {
        display: flex;
        align-items: flex-start;
        line-height: 1.3rem;
      }
    }

    &--is-positive,
    &--is-neutral,
    &--is-negative {
      position: relative;
      &:after {
        width: calc(100% - 16px);
        content: "";
        height: 3px;
        position: absolute;
        left: 0;
        right: 0;
        margin: 0 auto;
        bottom: 0;
      }
    }

    &--is-positive {
      &:after {
        background: #29c15b;
      }
    }
    &--is-neutral {
      &:after {
        background: #dbda1f;
      }
    }
    &--is-negative {
      &:after {
        background: #ff306e;
      }
    }
  }

  &__sort-btn {
    display: flex;
    align-items: center;
    margin-left: $spacing * 2;
  }

  ::v-deep &__sort-icon {
    color: $grey-darker;

    &--active {
      color: $primary;
    }

    &--in-active {
      color: $gray-2;
    }

    &--down {
      transform: rotate(180deg);
    }
  }
}
</style>
